import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function ProgressAnimation({ loading = null, ...props }) {
  const classes = useStyles();

  if (!loading) return null;

  return (
    <div className={classes.root}>
      <CircularProgress color="secondary" {...props} />
    </div>
  );
}
